import type { SearchFilters } from '../hooks/useSearch'

interface SearchFiltersPanelProps {
  filters: SearchFilters
  onChange: (filters: SearchFilters) => void
  onClose: () => void
}

export function SearchFiltersPanel({ filters, onChange, onClose }: SearchFiltersPanelProps) {
  const updateFilter = <K extends keyof SearchFilters>(
    key: K,
    value: SearchFilters[K]
  ) => {
    onChange({ ...filters, [key]: value })
  }

  const clearFilters = () => {
    onChange({})
  }

  const hasActiveFilters = Object.values(filters).some(Boolean)

  return (
    <div className="search-filters-panel">
      <div className="filters-header">
        <h4>Filters</h4>
        {hasActiveFilters && (
          <button className="clear-filters" onClick={clearFilters}>
            Clear all
          </button>
        )}
      </div>

      <div className="filter-group">
        <label className="filter-label">Status</label>
        <div className="filter-options">
          <button
            className={filters.isRead === undefined ? 'active' : ''}
            onClick={() => updateFilter('isRead', undefined)}
          >
            All
          </button>
          <button
            className={filters.isRead === false ? 'active' : ''}
            onClick={() => updateFilter('isRead', false)}
          >
            Unread
          </button>
          <button
            className={filters.isRead === true ? 'active' : ''}
            onClick={() => updateFilter('isRead', true)}
          >
            Read
          </button>
        </div>
      </div>

      <div className="filter-group">
        <label className="filter-label">Type</label>
        <div className="filter-options">
          <button
            className={!filters.sourceType ? 'active' : ''}
            onClick={() => updateFilter('sourceType', undefined)}
          >
            All
          </button>
          <button
            className={filters.sourceType === 'article' ? 'active' : ''}
            onClick={() => updateFilter('sourceType', 'article')}
          >
            Articles
          </button>
          <button
            className={filters.sourceType === 'youtube' ? 'active' : ''}
            onClick={() => updateFilter('sourceType', 'youtube')}
          >
            YouTube
          </button>
          <button
            className={filters.sourceType === 'pdf' ? 'active' : ''}
            onClick={() => updateFilter('sourceType', 'pdf')}
          >
            PDF
          </button>
          <button
            className={filters.sourceType === 'newsletter' ? 'active' : ''}
            onClick={() => updateFilter('sourceType', 'newsletter')}
          >
            Newsletter
          </button>
        </div>
      </div>

      <div className="filter-group">
        <label className="filter-checkbox">
          <input
            type="checkbox"
            checked={filters.isFavorite === true}
            onChange={(e) => updateFilter('isFavorite', e.target.checked ? true : undefined)}
          />
          <span className="checkbox-label">Favorites only</span>
        </label>
      </div>

      <div className="filter-group">
        <label className="filter-label">Date range</label>
        <div className="date-inputs">
          <input
            type="date"
            value={filters.dateFrom || ''}
            onChange={(e) => updateFilter('dateFrom', e.target.value || undefined)}
            placeholder="From"
          />
          <span className="date-separator">to</span>
          <input
            type="date"
            value={filters.dateTo || ''}
            onChange={(e) => updateFilter('dateTo', e.target.value || undefined)}
            placeholder="To"
          />
        </div>
      </div>

      <button className="apply-filters" onClick={onClose}>
        Apply Filters
      </button>
    </div>
  )
}
